import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import Video from 'components/Video';
import { useStyles } from './styles';
import CustomButton from 'components/CustomButton';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import useIsMobile from 'hooks/useIsMobile';

export default function Header() {
  const classes = useStyles();
  const router = useRouter();
  const isMobile = useIsMobile();

  function handleURL() {
    return `/auth/login-register/?from_url=${router.basePath + router.asPath}`;
  }

  return (
    <Box id="header" className={classes.root}>
      <Container>
        <Box className={classes.content}>
          <Box>
            <Typography component="h1" variant="h4">
              <b>
                Create professional <br /> medical & biology <br /> posters with no effort
              </b>
            </Typography>

            <Box py={3}>
              <Typography>
                <b>
                  Design informative, publication-ready medical <br /> and biology posters of any
                  subject. <br /> Browse illustrations from human medicine to cardiology and 80+{' '}
                  <br /> scientific fields.
                </b>
              </Typography>
            </Box>

            <NextLink href={handleURL()} passHref={true}>
              <CustomButton>{!isMobile ? 'Start Creating Now' : 'SIGN UP FOR FREE'}</CustomButton>
            </NextLink>

            {!isMobile && (
              <Box display="flex" mt={2}>
                <Box mr={0.8}>
                  <Typography variant="body1" component="p">
                    Already signed up?
                  </Typography>
                </Box>

                <NextLink href={handleURL()} passHref={true}>
                  Log in
                </NextLink>
              </Box>
            )}
          </Box>

          <Box className={classes.videoWrapper}>
            <Video
              className={classes.video}
              sources={[
                { src: '/videos/new-header-banner-new-workspace.webm', type: 'video/webm' },
              ]}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
